export function setAccessToken (state, token) {
  state.accessToken = token
}

export function setUser (state, user) {
  state.user = user
}

export function setOrganization (state, organization) {
  state.organization = organization
}

export function setSoftswitchIntegration (state, integration) {
  state.softswitchIntegration = integration
}

export function setFinancialData (state, financialData) {
  state.financialData = financialData
}

export function setImpersonation (state, impersonation) {
  state.impersonation = impersonation
}

export function clearImpersonation (state) {
  state.impersonation = null
}

export function setOnboarding (state, onboarding) {
  state.onboarding = onboarding
}



// WEBPACK FOOTER //
// ./src/store/modules/auth/mutations.js